/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Customer phone-call operation.
 */
export type EmployeeExecutionPhoneCallOperation = {
    /**
     * Stable operation discriminator.
     */
    kind: EmployeeExecutionPhoneCallOperation.kind;
    /**
     * Business purpose of the call.
     */
    purpose: string;
};
export namespace EmployeeExecutionPhoneCallOperation {
    /**
     * Stable operation discriminator.
     */
    export enum kind {
        PHONE_CALL = 'phone-call',
    }
}

